import { MenuOutlined } from "@ant-design/icons";
import { Button, Checkbox, Popover } from "@pankod/refine-antd";
import type { CheckboxValueType } from "antd/es/checkbox/Group";
import React from "react";

export interface ColumnProps {
  options: {
    label: string;
    value: string;
  }[];
  setHideCols: (val: CheckboxValueType[]) => void;
  defaultColumn: CheckboxValueType[];
}

export const ButtonColumn: React.FC<ColumnProps> = ({
  options,
  setHideCols,
  defaultColumn,
}) => {
  const onChange = (checkedValues: CheckboxValueType[]) => {
    setHideCols(checkedValues);
  };

  const content = (
    <div>
      <Checkbox.Group
        options={options}
        defaultValue={defaultColumn}
        onChange={onChange}
      />
    </div>
  );

  return (
    <Popover
      placement="bottom"
      title="View Column"
      content={content}
      trigger="click"
    >
      <Button style={{ marginRight: "10px" }}>
        <MenuOutlined />
      </Button>
    </Popover>
  );
};
